"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultsMessage = ResultsMessage;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InfoAlert = require("../alerts/InfoAlert");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line complexity


function ResultsMessage(props) {
  var appendMessage = props.appendMessage ? "; ".concat(props.appendMessage) : '';

  if (!props.hasReachedThreshold) {
    var entityNames = props.labels && props.labels.entityNames ? props.labels.entityNames : props.resultsLabels.results;
    return (
      /*#__PURE__*/
      _react["default"].createElement(_InfoAlert.InfoAlert, null, "".concat(props.resultsLabels.resultsMessage).concat(props.resultsCount, " ").concat(entityNames).concat(appendMessage))
    );
  }

  var messageTruncated = props.labels && props.labels.resultsMessageTruncated ? props.labels.resultsMessageTruncated : props.resultsLabels.resultsMessageTruncated;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_InfoAlert.InfoAlert, null, "".concat(messageTruncated).concat(props.resultsCount).concat(appendMessage))
  );
}

ResultsMessage.propTypes = {
  hasReachedThreshold: _propTypes["default"].bool.isRequired,
  resultsCount: _propTypes["default"].number.isRequired,
  resultsLabels: _propTypes["default"].shape({
    results: _propTypes["default"].string,
    resultsMessage: _propTypes["default"].string,
    resultsMessageTruncated: _propTypes["default"].string
  }).isRequired,
  appendMessage: _propTypes["default"].string,
  labels: _propTypes["default"].instanceOf(Object)
};
ResultsMessage.defaultProps = {
  appendMessage: '',
  labels: null
};